import _ from 'lodash'
import type {DocumentManager} from '@wix/document-manager-core'
import {cleanBrokenReferences} from './utils/variantRelationUtils'
import {stripHashIfExists} from '../../../../utils/refArrayUtils'
import type {PageMigrator} from '../dataMigrationRunner'

const migratePage = (documentManager: DocumentManager, pageId: string) => {
    const valuesTorefMap = documentManager.pointers.data
        .getLayoutItemsWithPredicate(layoutItem => layoutItem.type === 'VariantRelation', pageId)
        .map(pointer => documentManager.dal.get(pointer))
        .filter(
            relation =>
                relation.variants.length > 1 &&
                relation.variants.every(
                    (ref: string) =>
                        documentManager.dal.get(documentManager.pointers.getPointer(stripHashIfExists(ref), 'variants'))
                            .type === 'BreakpointRange'
                )
        )
        .reduce((refMap, relation) => ({...refMap, [relation.id]: relation}), {})
    cleanBrokenReferences(documentManager, 'layout', pageId, valuesTorefMap, _.stubTrue)
}

const name = 'fixBrokenScopedLayout'
const version = 1

export const fixBrokenScopedLayout: PageMigrator = {
    migratePage,
    name,
    version
}
